import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './AdBanner.module.css';

const bannerData = [
    {
        id: 1,
        title: "신안 천일염 할인",
        desc: "최대 30% 할인 (~12.31)",
        brand: "SINAN SEA SALT",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-i_jms0RmyaeecFcshhzsLgxeaXoazg8lig&s",
        link: "https://www.foodspring.co.kr/goods/detail/477624?srsltid=AfmBOoonTgWpCbSt1ueO4wsQaPOOsZzR_DQaPd8lyWp1xfFdIxQhZQgh"
    },
    {
        id: 2,
        title: "신라면(120g*5)",
        desc: "신규가입 시 최대 7,000원 할인 쿠폰 증정",
        brand: "Shin Ramyun",
        img: "https://nongshimmall.com/web/product/big/202408/9bc3396f8f570bd9b8f45dac0bfc9973.jpg",
        link: "https://nongshimmall.com/product/detail.html?product_no=4245"
    },
    {
        id: 3,
        title: "국내산 한입밤고구마(햇)",
        desc: "500g, 1개",
        brand: "Chestnut Sweet Potato",
        img: "https://asset.m-gs.kr/prod/1002488143/1/550",
        link: "https://www.coupang.com/vp/products/5532336625?itemId=8685540289&vendorItemId=75972634868&sourceType=CATEGORY&categoryId=194348&traceId=mjz9ldev"
    }
];

const AdBanner = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % bannerData.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.bannerContainer}>
            <AnimatePresence>
                <motion.a
                    key={bannerData[index].id}
                    className={styles.bannerCard}
                    href={bannerData[index].link}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ x: 352 }}
                    animate={{ x: 0 }}
                    exit={{ x: -352 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                    <div className={styles.bannerText}>
                        <p className={styles.bannerTitle}>{bannerData[index].title}</p>
                        <p className={styles.bannerSubtitle}>{bannerData[index].desc}</p>
                        <p className={styles.bannerBrand}>{bannerData[index].brand}</p>
                    </div>
                    <img className={styles.bannerImage} src={bannerData[index].img} alt={bannerData[index].title} />
                </motion.a>
            </AnimatePresence>
        </div>
    );
};

export default AdBanner;
